export default __webpack_public_path__ + "static/media/team4.76e31378.jpg";